import { render, staticRenderFns } from "./AppDetails.vue?vue&type=template&id=9f79bb28&scoped=true&"
import script from "./AppDetails.vue?vue&type=script&lang=js&"
export * from "./AppDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f79bb28",
  null
  
)

export default component.exports